import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import globalUserProfile from '../../../../../stores/global-user-profile';

export const updateLectureNameProfessorOperation = async (
  programId: number,
  courseId: number,
  lectureId: number,
  lectureName: string,
  setIsLoading: (loading: boolean) => void,
): Promise<boolean> => {
  try {
    setIsLoading(true);
    await appApi.updateLectureName(programId, courseId, lectureId, lectureName);
    await globalUserProfile.getUserProfile();
    toast.success('שם המפגש עודכן בהצלחה');
    return true;
  } catch (e) {
    console.error(
      `updateLectureNameProfessorOperation is failed with the programId: ${programId}, courseId: ${courseId}, lectureId: ${lectureId}, lectureName: ${lectureName} with the error: ${e}`,
    );
    toast.error('משהו קרה, לא ניתן לעדכן את שם המפגש...');
    return false;
  } finally {
    setIsLoading(false);
  }
};
